import { API_URL, SPA_URL } from '@/constants/api';

export const lioboCustomer = async (shopifyCustomerId: string) => {
  const res = await fetch(`${API_URL}/admin/auth/liobo`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accessToken') ?? ''}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ shopifyCustomerId }),
    credentials: 'include',
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`LIOBO failed (${res.status}): ${text}`);
  }

  window.open(`${SPA_URL}`, '_blank', 'noopener');
};
